<template>
	<j-expendable-box class="bg5 b1 bc7 r2">
		<!-- Header -->
		<div slot="header" class="pl3 pr3 pt4 pb4 lh125 fs4 c1 fw7">
			{{ $t("product") }}
		</div>

		<!-- Body -->
		<div class="bt1 bc7 p4" slot="body">
			<!-- Label -->
			<label class="xs-12 fs4 fw7 lh125">{{ $t("select_product") }}</label>
			<core-select-product
				:value="computedValue"
				:insuranceType="computedType"
				:allowSelectNothing="false"
				@input="onInput"
			/>
		</div>
	</j-expendable-box>
</template>

<script>
import CoreSelectProduct from "@/modules/core/components/CoreSelectProduct"
import JExpendableBox from "@/components/JExpendableBox"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		CoreSelectProduct,
		JExpendableBox
	},

	data() {
		return {
			isLoading: false,
			form: {}
		}
	},

	methods: {
		async onInput(payload) {
			const query = gql`
				mutation updateOfferOfProposal(
					$caseId: String!
					$proposalId: String!
					$offerId: String!
					$input: updateOfferInput!
				) {
					updateOfferOfProposal(
						caseId: $caseId
						proposalId: $proposalId
						offerId: $offerId
						updateOfferInput: $input
					) {
						status
						errors
					}
				}
			`

			const variables = {
				caseId: this.$store.state.caseManagement.caseId,
				proposalId: this.$store.state.caseManagement.proposalId,
				offerId: this.$store.state.caseManagement.offerId,
				input: {
					productId: payload?.[0]?.productId
				}
			}

			const res = await api({ query, variables })

			if (res?.data?.updateOfferOfProposal?.status !== "success") {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text:
							res?.errors ||
							res?.data?.updateOfferOfProposal?.errors ||
							res?.data?.updateOfferOfProposal?.errors_2.message ||
							"Oops ! An error occured."
					}
				})
			}

			const stateFilter = function(state) {
				return state.proposals
					?.find(item => item.id === state?.proposalId)
					?.basket?.find(item => item.id === state?.offerId)
			}
			// Update type
			this.$store.commit("caseManagement/UPDATE_CASE", {
				actionType: "update",
				fieldName: "product",
				value: payload?.[0],
				stateFilter
			})
		}
	},

	computed: {
		computedValue() {
			const product = this.$store.getters["caseManagement/offer"]?.product
			return product
				? [
						{
							name: product?.name,
							value: product?.productId
						}
				  ]
				: []
		},
		computedType() {
			const product = this.$store.getters["caseManagement/offer"]?.product
			return product ? product.productId.type : null
		}
	}
}
</script>
